import { Box, Typography, Grid } from "@mui/joy";
import { Controller, useFormContext } from "react-hook-form";
import { Switch as JoySwitch } from "@mui/joy";

import { TextField, Textarea } from "../../../../../shared";
import { LogoUploadField } from "../../LogoUploadField";

export function OrganizationConfiguration() {
    const { control } = useFormContext();

    return (
        <Box flex={1}>
            <Box mt={2} display="flex" flexDirection="column" gap={1.5}>
                <LogoUploadField />

                <TextField
                    name="Name"
                    label="Organization Name"
                    helperText="Enter the name of the organization"
                    placeholder="e.g., Colorado Roofing Company"
                />

                <TextField
                    name="ShortName"
                    label="Short Name"
                    helperText="Optional short name or abbreviation"
                    placeholder="e.g., CRC"
                />

                <Textarea
                    name="Description"
                    label="Description"
                    helperText="Optional summary of the organization"
                    placeholder="e.g., Regional roofing contractor serving Colorado homeowners"
                    minRows={3}
                />

                <Grid container spacing={2}>
                    <Grid xs={12}>
                        <TextField
                            name="Website"
                            label="Website"
                            helperText="Optional organization website"
                            placeholder="e.g., https://www.example.com"
                        />
                    </Grid>
                </Grid>

                <Box mt={1}>
                    <Typography level="body-sm" sx={{ mb: 1, fontWeight: 500 }}>
                        Active Status
                    </Typography>
                    <Controller
                        name="IsActive"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <JoySwitch
                                checked={!!value}
                                onChange={(event) => onChange(event.target.checked)}
                                sx={{
                                    "--Switch-thumbSize": "16px",
                                    "--Switch-trackWidth": "36px",
                                    "--Switch-trackHeight": "20px",
                                }}
                            />
                        )}
                    />
                </Box>
            </Box>
        </Box>
    );
}
